import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/material/styles';
import AccordionSummary from '@mui/material/AccordionSummary';


export const StyledAccordionSummary = styled(AccordionSummary)(({ theme, expanded }) => ({
    backgroundColor: '#F3F3FA',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #E7E7FF',
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
    borderBottomLeftRadius: expanded ? '0px' : '10px',
    borderBottomRightRadius: expanded ? '0px' : '10px',
    cursor: 'default',
    pointerEvents: 'none',
    '&.Mui-expanded': {
        minHeight: 0,
    },
    '& .MuiAccordionSummary-content': {
        margin: '12px !important',
    },
}));


export const StyledExpandMoreIcon = styled(ExpandMoreIcon)(({ theme }) => ({
    cursor: 'pointer',
    pointerEvents: 'auto',
    alignSelf: 'center',
}));


export const TitleTypography = styled(Typography)(({ theme }) => ({
    fontSize: '16px',
    display: "flex",
    alignItems: "baseline",
    fontWeight: 600,
    lineHeight: '23px',
    fontFamily: 'Figtree-Regular',
    textAlign: 'left',
    color: 'var(--Purple-300, #404585)',
    padding: '3px 10px',
    borderRadius: '4px'
}));